import produce from 'immer';

const INITIAL_STATE = {
  ad_detail: '',
};

export default function sells(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@sells/AD_DETAIL': {
        draft.ad_detail = action.payload.ad_detail;
        break;
      }
      default:
    }
  });
}
